import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PAGES_URLS } from '../constants';
import { ConfigurationQueryService } from '../service';

export const venuesGuard: CanActivateFn = () => {
  const router = inject(Router);
  const redirectUrl = router.createUrlTree([PAGES_URLS.HotelReservations]);
  const configService = inject(ConfigurationQueryService);
  const features = configService.features();

  return features?.venues || redirectUrl;
};
